import { defineField, defineType } from "sanity";

export const emailLog = defineType({
  name: "emailLog",
  title: "Email Log",
  type: "document",
  fields: [
    defineField({
      name: "sentAt",
      title: "Sent at",
      type: "datetime",
      readOnly: true,
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "templateName",
      title: "Template name",
      type: "string",
      readOnly: true
    }),
    defineField({
      name: "subject",
      title: "Subject",
      type: "string",
      readOnly: true
    }),
    defineField({
      name: "groupName",
      title: "Group name",
      type: "string",
      readOnly: true
    }),
    defineField({
      name: "groupTag",
      title: "Group tag",
      type: "string",
      readOnly: true
    }),
    defineField({
      name: "recipientCount",
      title: "Recipient count",
      type: "number",
      readOnly: true
    }),
    defineField({
      name: "successCount",
      title: "Success count",
      type: "number",
      readOnly: true
    }),
    defineField({
      name: "failedCount",
      title: "Failed count",
      type: "number",
      readOnly: true
    })
  ],
  preview: {
    select: {
      title: "subject",
      groupName: "groupName",
      recipientCount: "recipientCount"
    },
    prepare: ({ title, groupName, recipientCount }) => ({
      title: title || "Untitled email",
      subtitle: `Sent to ${groupName ?? "unknown group"} \u2022 ${recipientCount ?? 0} recipients`
    })
  }
});
